export const END_POINTS = {
  NEWS_LIST: "/news",
  NEWS_ITEM: (item: string | number) => `/news/${item}/items`,
  SEARCH_NEWS_ITEM: "/news/items/search",
};
